import React, {useEffect} from "react";
import {Col, Row} from "react-bootstrap";
import TextArea from "../../../common/TextArea";
import Input from "../../../common/Input";
import DateBox from "../../../primer/DateBox";
import {useDispatch, useSelector} from "react-redux";
import {setSaveNewCashRegister} from "../../../../_reducers/activitySlice";
import Checkbox from "../../../common/CheckBox";
import {setNewCashRegisters} from "../../../../_reducers/DataPanel/Cash/cashSlice";
import {checkPermission, isEmpty} from "../../../../_helpers/commonFunctions";
import {fetchCashSettings} from "../../../../_apis/api";
import {useTranslation} from "../../../../hooks/useTranslation";

const CashRegistersNew = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const saveNewCashRegister = useSelector((state) => state.ACTIVITY.saveNewCashRegister);
    const newCashRegisters = useSelector((state) => state.CASH_DATA.newCashRegisters);
    const cashSettings = useSelector((state) => state.CASH_DATA.cashSettings);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const permissionsData = JSON.parse(localStorage.getItem("user"))?.permissions;

    useEffect(() => {
        dispatch(fetchCashSettings(company.id));
    }, [])

    useEffect(() => {
        if (!isEmpty(cashSettings?.accounting?.accountingCashRegister) && isEmpty(newCashRegisters.name)) {
            dispatch(setNewCashRegisters({...newCashRegisters, accounting: cashSettings.accounting.accountingCashRegister}))
        }
    }, [cashSettings.accounting])

    const handleOnChange = (e, type = "default", ddname = '') => {
        if (!saveNewCashRegister) dispatch(setSaveNewCashRegister(true));

        let name;
        let value;
        if (type === 'dp') {
            value = e;
            name = ddname;
        } else {
            value = e.target.value;
            name = e.target.name;
        }
        const newCashRegistersData = {};
        newCashRegistersData[name] = value;
        dispatch(setNewCashRegisters({...newCashRegisters, ...newCashRegistersData}));
    }

    return (
        <React.Fragment>
            <Row className="position-relative border-bottom mb-3">
                <Col xs="12" md="12" className="d-flex align-items-center justify-content-end ">
                    <div className="inline-field d-flex align-items-center acremd  mb-3">
                        <label htmlFor="product-active" className="mb-0 mr-2">{t('cashRegistersNew.active')}</label>
                        <Checkbox
                            className="mb-2"
                            name="isActive"
                            key={Math.random()}
                            id="product-active"
                            defaultValue={newCashRegisters.isActive}
                            value={newCashRegisters.isActive === 'active' ? "inactive" : "active"}
                            onChange={(e) => handleOnChange(e)}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col sm="12" md="4">
                    <div className="mb-3">
                        <Input
                            className="w-100"
                            label={t('cashRegistersNew.name.name')}
                            name="name"
                            placeholder={t('cashRegistersNew.name.placeholder')}
                            value={newCashRegisters.name}
                            required={true}
                            onChange={(e) => handleOnChange(e)}
                        />
                        {saveNewCashRegister && newCashRegisters.name === '' &&
                            <div className="text-danger">{t('cashRegistersNew.name.required')} </div>}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col sm="12" md="4">
                    <div className="mb-3">
                        <DateBox
                            classes="w-100"
                            label={t('cashRegistersNew.date.date')}
                            name="date"
                            required={true}
                            selected="today"
                            allowOtherYears={true}
                            onChange={(e) => handleOnChange(e, 'dp', 'date')}
                        />
                        {saveNewCashRegister && isEmpty(newCashRegisters.date) &&
                            <div className="text-danger">{t('cashRegistersNew.date.required')}</div>}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col sm="12" md="8">
                    <div className="mb-3">
                        <Input
                            className="w-100"
                            label={t('cashRegistersNew.serialNumber.serialNumber')}
                            name="serialNumber"
                            placeholder={t('cashRegistersNew.serialNumber.placeholder')}
                            value={newCashRegisters.serialNumber}
                            required={true}
                            onChange={(e) => handleOnChange(e)}
                        />
                        {saveNewCashRegister && newCashRegisters.serialNumber === '' &&
                            <div className="text-danger">{t('cashRegistersNew.serialNumber.required')}</div>}
                    </div>
                </Col>
            </Row>
            <hr className="mb-4"/>
            <Row>
                <div style={{width: "100%"}}>
                    <div className="text-muted mb-2"><i>{t('cashRegistersNew.notes')}</i></div>
                    <TextArea
                        rows="4"
                        placeholder={t('cashRegistersNew.addNotes')}
                        name="notes"
                        limit="1000"
                        value={newCashRegisters.notes}
                        onChange={(e) => handleOnChange(e)}
                    />
                </div>
            </Row>
            {checkPermission("accounting-settings/accounting-read", permissionsData) === true && (
                <React.Fragment>
                    <hr/>
                    <div className="text-muted mb-2"><i>Λογιστική</i></div>
                    <Row className={"mb-2"}>
                        <Col md={4}>
                            <Input
                                name={"accounting"}
                                label={"Πρόθεμα Κωδικού Λογαριασμού"}
                                value={newCashRegisters?.accounting}
                                onChange={(e) => handleOnChange(e)}
                            />
                        </Col>
                        <Col md={4}>
                            <Input
                                name={"bypassAccounting"}
                                label={"Κωδικός Λογαριασμού Παράκαμψης Λογιστικής Γέφυρας"}
                                value={newCashRegisters?.bypassAccounting}
                                onChange={(e) => handleOnChange(e)}
                            />
                        </Col>
                    </Row>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default CashRegistersNew;
